import apiWrapper, { extractApiData } from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'
import {
  type EmailMessage,
  type SearchMessagesQueryParams,
  type LinkResponse,
  type SearchEmailBody,
} from '../types/beMessageApi'
import { type PagedList } from '../types/beFiltersApi'

const endpoints = ((baseURL: string) => {
  return {
    searchEmailMessages: (idList: number, qs: SearchMessagesQueryParams) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/messages/search?${encodeParams(qs) as unknown as string}`,
    getEmailMsgDetails: (idMessage: number) =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}/lazy`,
    getMessageLinks: (idMessage: number) =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}/links`,
  }
})(process.env.BEEMAILMESSAGE_URL as unknown as string)

export const beEmailMessageApiSearchEmailMessages = async (
  idList: number,
  params: SearchMessagesQueryParams,
  body: SearchEmailBody,
): Promise<PagedList<EmailMessage>> => {
  return await apiWrapper({
    method: 'post',
    url: endpoints.searchEmailMessages(idList, params),
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(body),
  }).then(extractApiData)
}
export const beEmailMessageApiGetEmailMsgLazy = async (
  idMessage: number,
): Promise<EmailMessage> => {
  return await apiWrapper({
    url: endpoints.getEmailMsgDetails(idMessage),
  }).then(extractApiData)
}

export const beEmailMessageApiGetMessageLinks = async (
  idMessage: number,
): Promise<LinkResponse> => {
  return await apiWrapper({
    url: endpoints.getMessageLinks(idMessage),
  }).then(extractApiData)
}
